import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ObjectMediaContainer, ObjectMediaType} from '../../core/definitions/object-media-container';
import {objectTypeToMatSymbol} from "../../shared/material-icons";
import {MediaSegment} from "../../core/definitions/media-segment";
import {msToTimecode} from '../../object-edit/edit-field-timecode/timecode.utils';
import {isMediaNotReady, mediaThumbnailFallbackIcon} from '../../shared/thumbnail-fallback-icon';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {MediaConversionWatcher} from '../../shared/media-conversion-watcher.service';

@Component({
  selector: 'app-thumbnail-stack',
  templateUrl: './thumbnail-stack.component.html',
  styleUrls: ['./thumbnail-stack.component.scss'],
  standalone: false
})
export class ThumbnailStackComponent {
  private readonly conversionWatcher = inject(MediaConversionWatcher, {optional: true});
  @Input() mediaContainer: ObjectMediaContainer;
  @Input() mediaType: ObjectMediaType;
  @Input() isEditing: boolean;
  @Input() imageGallery;
  @Input() rootObject: any;
  @Output() setActiveImg = new EventEmitter<object>();
  @Output() setActiveSegment = new EventEmitter<{ index: number, segment: MediaSegment }>();

  // Failed per url, so a tile recovers when its thumbnail url changes
  private readonly invalidSrcs = new Set<string>();

  setMedia(index) {
    const mediaIndex = {
      index: index
    };
    this.setActiveImg.emit(mediaIndex);
  }

  onThumbnailError(media: SuperObjectModel) {
    this.setInvalidSrc(media.$$thumbUrl);
    this.conversionWatcher?.watch(media);
  }

  setInvalidSrc(url: string) {
    this.invalidSrcs.add(url);
  }

  isInvalidSrc(url: string): boolean {
    return this.invalidSrcs.has(url);
  }

  setSegment(index: number, segment: MediaSegment) {
    this.setActiveSegment.emit({index, segment});
  }

  getMaterialSymbol(objectType: string) {
    return objectTypeToMatSymbol(objectType);
  }

  tileClasses(index: number, segment?: MediaSegment) {
    return {
      'thumbnail-stack__inner--selected': segment
        ? segment.segmentId === this.mediaContainer.currentSegmentId
        : (index === this.mediaType.currentMediaIndex &&
          this.mediaType.mediaType === this.mediaContainer.currentMediaType.mediaType),
      'thumbnail-stack__inner--segment-selected': !segment && !!this.mediaContainer.currentSegmentId
    };
  }

  protected readonly msToTimecode = msToTimecode;
  protected readonly mediaFallbackIcon = mediaThumbnailFallbackIcon;
  // While the media converts the tile shows the hourglass, also over an image that loads (the audio placeholder)
  protected readonly isNotReady = isMediaNotReady;
}
